export enum ContestConfigPeriodicityEnum {
  ONCE = "ONCE",
  ONCE_USER = "ONCE_USER",
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  EVERY = "EVERY"
}
